import { gql } from '@/lib/graphql/gql'

export const DELETE_COMPANY_SHEET_QUERY = gql`
  query DeleteCompanySheet {
    user {
      id
      companies {
        id
        name
      }
    }
  }
`

export const CANCEL_SEVALLA_ACCOUNT_MUTATION = gql`
  mutation CancelSevallaAccount(
    $idCompany: String!
    $deleteAccount: Boolean
    $cancellationReason: String
    $cancellationFeedback: String
  ) {
    cancelSevallaAccount(
      idCompany: $idCompany
      deleteAccount: $deleteAccount
      cancellationReason: $cancellationReason
      cancellationFeedback: $cancellationFeedback
    ) {
      status
      charged
      forgiven
      accountDeletionRequested
    }
  }
`
